// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2HdEv","header":"PatientBlock_header__2sXk7","label":"PatientBlock_label__1mu0V","option":"PatientBlock_option__jz74-"};